import { CSSProperties, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faEnvelope, faPhotoFilm } from "@fortawesome/free-solid-svg-icons";
import { SiteSyles, useIsVisible, useSite } from "../Context/SiteContext";

export const LandingPage = () => {

    const Site = useSite();

    const pageRef = useRef<HTMLDivElement>(null);

    useEffect(()=>{
        Site.pageRef!.current = pageRef?.current;
    },[]);

    return(
        <div ref={pageRef} style={{
            display:'flex',
            position:'relative',
            height:'100vh',
            width:'100vw',
            flexShrink:0,
            alignItems:'center',
            justifyContent:'center',
            backgroundColor:'black',
            overflow:'hidden',
        }}>
            <VideoBanner></VideoBanner>
            <LandingMenu></LandingMenu>
            <TypingDisplay></TypingDisplay>
        </div>
    );

};

const LandingMenu = () => {

    return(
        <div style={{
            display:'flex',
            position:'absolute',
            inset: 20,
        }}>
            <div style={{
                position:'relative',
                display:'flex',
                flexDirection:'column',
                flex:1,
                justifyContent:'center',
                alignItems:'flex-end',
            }}>                
                <EmailLink></EmailLink>
                <ProvenceLink></ProvenceLink>
                <PortfolioPrompt></PortfolioPrompt>
                <NameDisplay></NameDisplay>
                <div style={{
                    position:'absolute',
                    bottom:0,
                    alignSelf:'center',
                    mixBlendMode:'plus-lighter',
                    filter:'blur(1px)',
                }}>
                    <FontAwesomeIcon icon={faChevronDown} style={{color:SiteSyles.siteYellow}}></FontAwesomeIcon>
                </div>
            </div>
        </div>
    );

};

const VideoBanner = () => {

    const [opacity, setOpacity] = useState(0);

    useEffect(()=>{
        setOpacity(1);
    },[]);

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoVisible ? videoRef.current?.play() : videoRef.current?.pause();
    },[videoVisible])

    return(
        <video ref={videoRef} autoPlay muted loop playsInline style={{
            position:'absolute',
            width:'100%',
            height:'100%',
            objectFit:'cover',
            opacity:opacity,
            transition: 'opacity 2s',
            transitionDelay: '1s'
        }}>
            <source src="assets/art-banner.mp4"></source>
            {/* <source src="assets/banner-video.mp4"/>
            <source src="assets/banner-video.mov"/> */}
        </video>
    );

};

const TypingDisplay = () => {

    const baseText = useRef('const value:{[id:string]x:number,y:number} = {id:"39@-%2",x:25,y:57}; MICHAEL YULL').current;

    const [index, setIndex] = useState(0);

    const [displayText,setDisplayText] = useState('');

    const timeoutRef = useRef<NodeJS.Timeout>(undefined);

    const [redVariation, setRedVariation] = useState(0);
    const [blurVariation, setBlurVariation] = useState(5);

    useEffect(()=>{
        let section = baseText.slice(0,index+1);
        setDisplayText(section);
        timeoutRef.current = setTimeout(()=>{
            let newValue = index + 1;
            if(newValue === baseText.length) newValue = 0;
            setIndex(newValue);
            setRedVariation(Math.random() * 100);
            setBlurVariation((1 + Math.random() * 7));
        },(Math.random() * 500) + 50);
    },[index]);

    return(
        <div style={{
            display:'flex',
            position:'absolute',
            top:0,
            left:0,
            right:'20vw',
            bottom:0,
            pointerEvents:'none',
            userSelect:'none',
            alignItems:'center',
            justifyContent:'flex-end',
            paddingBottom:'10vh',
            filter:`blur(${blurVariation}px)`,
            mixBlendMode:'lighten',
            overflow:'hidden',
        }}>
            <div style={{
                color:`rgb(${redVariation},0,255)`,                
                whiteSpace:'nowrap',
                fontSize:'160vh',
                textShadow:'0px 0px 40px',
            }}>
                {displayText}
            </div>
        </div>
    );

};

export const DrawOnText = (props:{
    text:string,
    minSpacing?:number,
    maxSpacing?:number,
    start?:boolean,
    style?:CSSProperties,
    onComplete?:()=>void
}) => {

    const text = useRef(props.text).current;
    const [drawIndex, setDrawIndex] = useState(0);
    const [drawnText, setDrawnText] = useState('')

    const incrementText = () => {
        if(drawIndex < text.length){
            setDrawnText(text.slice(0,drawIndex + 1));
            setTimeout(()=>{
                setDrawIndex(drawIndex + 1);
            },(Math.random() * (props.maxSpacing ?? 150)) + (props.minSpacing ?? 50));
        }else props.onComplete?.();
    };

    useEffect(()=>{
        if(props.start){
            incrementText();
        }
    },[props.start,drawIndex])

    return(
        <div style={{
            color:`rgb(255,255,0)`,
            fontSize:36,
            fontFamily:'Science Gothic',
            whiteSpace:'nowrap',              
            textShadow:'0px 0px 5px',
            userSelect:'none',
            ...props.style,

        }}>{drawnText}</div>
    );

};

const NameDisplay = () => {

    const Site = useSite();

    const [lineOneStart, setLineOneStart] = useState(false);
    const [lineTwoStart, setLineTwoStart] = useState(false);
    const [lineThreeStart, setLineThreeStart] = useState(false);

    useEffect(()=>{
        setTimeout(()=>setLineOneStart(true),1000);
    },[]);

    return(        
        <div style={{
            position:'absolute',
            top:0,
            display:'flex',
            flexDirection:'column',
            mixBlendMode:'plus-lighter',
            alignItems:'flex-end',
            filter:'blur(1px)',
        }}>
            <DrawOnText text="MICHAEL YULL" start={lineOneStart} onComplete={()=>{
                setTimeout(()=>setLineTwoStart(true),300);
            }}></DrawOnText>
            <DrawOnText text="DEVELOPER"  start={lineTwoStart} onComplete={()=>{
                setTimeout(()=>setLineThreeStart(true),300);
            }}></DrawOnText>
            <DrawOnText text="DESIGNER"  start={lineThreeStart} onComplete={()=>{
                Site.nameDrawn.set!(true);
            }}></DrawOnText>
        </div>            
    );

};

const PortfolioPrompt = () => {

    const Site = useSite();

    const [show, setShow] = useState(false);

    useEffect(()=>{
        Site.nameDrawn.get && setTimeout(()=>{
            setShow(true)
        },200);
    },[Site.nameDrawn.get]);

    return(
        <div style={{
            position:'absolute',
            display: show ? 'flex' : 'none',
            alignItems:'center',
            mixBlendMode:'plus-lighter',
            gap:10,
            cursor:'pointer',
            transform:'translateY(-25px)',
            filter:'blur(1px)',
        }} onClick={()=>{
            window.open('/portfolio','_self');
        }}>
            <FontAwesomeIcon icon={faPhotoFilm} style={{color:"#ffff00",fontSize:24}}></FontAwesomeIcon>
            <DrawOnText text="PORTFOLIO" start={show} style={{
                fontSize:28,
            }} onComplete={()=>{
                Site.menuItemsDrawn.set!(1);
            }}></DrawOnText>
        </div>
    );

};

const ProvenceLink = () => {

    const Site = useSite();

    const [show, setShow] = useState(false);

    useEffect(()=>{
        Site.menuItemsDrawn.get === 1 && setTimeout(()=>{
            setShow(true)
        },100);
    },[Site.menuItemsDrawn.get]);

    return(
        <div style={{
            position:'absolute',
            display: show ? 'flex' : 'none',
            alignItems:'center',
            mixBlendMode:'plus-lighter',
            gap:10,
            cursor:'pointer',
            transform:'translateY(25px)',
            filter:`blur(1px)`,
        }} onClick={()=>{
            Site.provenceElementRef?.current?.scrollIntoView({behavior:'smooth'});
        }}>
            <img src="assets/provence-logo.png" style={{
                bottom:0,
                height:28,
                objectFit:'contain',
                mixBlendMode:'plus-lighter',
            }}></img>
            <DrawOnText text="PROVENCE" start={show} style={{
                fontSize:28,
            }} onComplete={()=>{
                Site.menuItemsDrawn.set!(2);
            }}></DrawOnText>
        </div>
    );
};

const EmailLink = () => {

    const Site = useSite();

    const [show, setShow] = useState(false);

    useEffect(()=>{
        Site.menuItemsDrawn.get === 2 && setTimeout(()=>{
            setShow(true)
        },200);
    },[Site.menuItemsDrawn.get]);

    return(
        <div style={{
            position:'absolute',
            bottom:20,
            display: show ? 'flex' : 'none',
            alignItems:'center',
            mixBlendMode:'plus-lighter',
            gap:10,
            cursor:'pointer',
            filter:'blur(1px)',
        }}>
            <FontAwesomeIcon icon={faEnvelope} style={{color:"#ffff00",fontSize:18}}></FontAwesomeIcon>
            <DrawOnText text="MICHAEL@MICHAELYULL.COM" start={show} style={{
                fontSize:16,
                userSelect:'inherit',
            }}></DrawOnText>
        </div>
    );

};